export const defaultPhotoOptions = {
  allow: true
};
export const defaultRecordOptions = {
  allow: false
};
export const defaultConfigOptions = {
  allow: true,
  audioInput: true,
  videoInput: true
};